import { z } from 'zod';

export const createEstablishmentProductSchema = z.object({
  product_id: z
    .object({
      label: z.string().min(1, { message: "O produto é obrigatório" }),
      value: z.string().min(1, { message: "O produto é obrigatório" }),
    })
    ,

  metric: z.string().min(1, { message: "O valor do produto é obrigatório" }),
});
